import React from 'react';
import VisaIcon from '../../assets/icons/visa.png';
import DiscoverIcon from '../../assets/icons/discover.png';
import MasterCardIcon from '../../assets/icons/mastercard.png';
import AmexIcon from '../../assets/icons/amex.png';
import DinersClubIcon from '../../assets/icons/dinersclub.png';
import JCBIcon from '../../assets/icons/jcb.png';
import MUICreditCardIcon from '@mui/icons-material/CreditCard';

export function CreditCardIcon(props) {
  const { cardType, width } = props;
  const iconWidth = width ? width : '50px';
  return (
    <>
      {cardType === 'Visa' ? (
        <img src={VisaIcon} alt='' width={iconWidth} height='auto' />
      ) : cardType === 'MasterCard' ? (
        <img src={MasterCardIcon} alt='' width={iconWidth} height='auto' />
      ) : cardType === 'American Express' ? (
        <img src={AmexIcon} alt='' width={iconWidth} height='auto' />
      ) : cardType === 'Discover' ? (
        <img src={DiscoverIcon} alt='' width={iconWidth} height='auto' />
      ) : cardType === 'Diners Club' ? (
        <img src={DinersClubIcon} alt='' width={iconWidth} height='auto' />
      ) : cardType === 'JCB' ? (
        <img src={JCBIcon} alt='' width={iconWidth} height='auto' />
      ) : (
        <MUICreditCardIcon sx={{ width: iconWidth, height: 'auto' }} />
      )}
    </>
  );
}
